// Generated by ts-to-zod
import {z} from "@AppBuilderLib/shared/lib/zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantineCheckboxPropsSchema = z.object({
	ml: mantineSpacingSchema.optional(),
	label: z.string().optional(),
});
